'use client';

import { motion, useMotionValueEvent, useScroll } from 'motion/react';
import { useRef, useState } from 'react';

import { Container } from '@/components/container';
import { Blink, Circle } from '@/components/icons';

const QUOTE =
    'Every company has values and principles but sometimes they are not clearly expressed. At SwingDev, our values can be used as guidance while making decisions, working, and having fun.';

export const QuoteSection = () => {
    const ref = useRef(null);
    const [progress, setProgress] = useState(0);

    const { scrollYProgress } = useScroll({
        offset: ['start end', 'start start'],
        target: ref,
    });

    useMotionValueEvent(scrollYProgress, 'change', () => {
        const offsetStart = 0.4;
        const offsetEnd = 0.2;
        const value = Math.min(
            1,
            Number(Math.max(0, scrollYProgress.get() - offsetStart)) /
                (1 - offsetStart - offsetEnd),
        );

        setProgress(value);
    });

    return (
        <Container verticalSpacing>
            <div
                className={`
                  relative rounded-3xl bg-primary-white px-6 pb-32 pt-24
                  text-primary-green transition-all duration-200

                  lg:rounded-none lg:px-16 lg:pt-32 lg:hover:rounded-[60px]

                  sm:pb-24
                `}
            >
                <div
                    className={`
                      text-center text-3xl font-bold leading-tight

                      lg:text-5xl lg:leading-[1.15]
                    `}
                    ref={ref}
                >
                    {QUOTE?.split('').map((char: string, index: number) => (
                        <motion.span
                            key={index}
                            initial={{ color: '#47B749' }}
                            animate={{
                                color:
                                    progress > index / QUOTE.length
                                        ? '#313131'
                                        : '#47B749',
                            }}
                            transition={{ duration: 0.1 }}
                            className="-mx-px"
                        >
                            {char}
                        </motion.span>
                    ))}
                </div>

                <div
                    className={`
                      mt-12 text-center font-normal text-primary-black

                      lg:mt-20
                    `}
                >
                    <p className="text-lg">Jo Overline</p>
                    <p className="text-sm">Co-Founder at SwingDev</p>
                    <p className="text-sm">CTO at Hippo</p>
                </div>

                <Circle
                    className={`
                      absolute left-8 top-8 -translate-x-1/2 -translate-y-1/2
                      text-primary-black

                      lg:left-12 lg:top-12
                    `}
                />
                <Circle
                    className={`
                      absolute bottom-8 right-8 translate-x-1/2 translate-y-1/2
                      text-primary-black

                      lg:bottom-12 lg:right-12
                    `}
                />
                <Blink
                    className={`
                      absolute right-8 top-8 -translate-y-1/2 translate-x-1/2

                      lg:right-12 lg:top-12
                    `}
                />
                <Blink
                    className={`
                      absolute bottom-8 left-8 -translate-x-1/2 translate-y-1/2

                      lg:bottom-12 lg:left-12
                    `}
                />
            </div>
        </Container>
    );
};

// const gradientAnimationClass = "animate-text-gradient bg-gradient-to-r from-primary-green to-primary-black bg-[200%_auto] bg-clip-text text-transparent"
